import { render, staticRenderFns } from "./BroadcastListCompnent.vue?vue&type=template&id=4449c5e3&scoped=true"
import script from "./BroadcastListCompnent.vue?vue&type=script&lang=js"
export * from "./BroadcastListCompnent.vue?vue&type=script&lang=js"
import style1 from "./BroadcastListCompnent.vue?vue&type=style&index=1&id=4449c5e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449c5e3",
  null
  
)

export default component.exports